import { SEARCH, HTTP } from '@/utils/http';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';
import * as mutationTypes from '@/store/types/mutations';

export default {
  actions: {
    async [actionTypes.DO_GET_PROJECT]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/events/${id}`, { params });
      commit(mutationTypes.SET_PROJECT, data.data.events[0]);
      return data;
    },
    async [actionTypes.DO_GET_PROJECTS]({ commit }, payload) {
      const response = await SEARCH.post('/doxa_events/_search', payload);
      const { hits } = response.data;
      commit(mutationTypes.SET_PROJECTS, hits.hits.map(h => h._source));
      return response.data;
    },
  },
  getters: {
    [getterTypes.GET_PROJECT]: state => state.project,
    [getterTypes.GET_PROJECTS]: state => state.projects,
  },
  mutations: {
    [mutationTypes.SET_PROJECT](state, payload) {
      state.project = payload;
    },
    [mutationTypes.SET_PROJECTS](state, payload) {
      state.projects = payload;
    },
  },
  state: {
    project: {},
    projects: [],
    pagination: {
      page: 1,
      per: 12,
      total: 0,
    },
  },
};
